import styled from "styled-components";

// import theme from "../../styledTheme/styledTheme";

// const mainStyledWidth = `calc(100vw - 2 * ${({ theme }) =>
//   theme.fixedMenuWidth}`;

const calcWidth = (size) => {
  if (["xm"].includes(size)) {
    return 0;
  }
  if (["xm", "sm", "md"].includes(size)) {
    return 1;
  }
  return 2;
};

export const MainStyled = styled.main`
  padding: ${({ theme }) =>
      !["xm"].includes(theme.windowWidth) ? "24px" : "10px"}
    10px;
  position: absolute;
  top: 0;
  right: ${({ theme }) =>
    !["xm"].includes(theme.windowWidth) ? theme.fixedMenuWidth : 0};
  width: ${({ theme }) =>
    `calc(100vw - ${calcWidth(theme.windowWidth)} * ${theme.fixedMenuWidth})`};

  height: 95%;

  @media (max-width: 768px) {
    height: 98%;
  }

  & > div:first-child {
    background-color: #f6f7f9;
    height: 100%;
    border-radius: 18px;
    padding: 25px;
    overflow: hidden;
  }
`;
export const MenueButton = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.05);
  /* padding: 0; */
  justify-content: center;
  align-items: center;
  display: ${({ theme }) =>
    !["xm"].includes(theme.windowWidth) ? "none" : "flex"};
  /* position: absolute; */
  /* left: 0; */
  height: 45px !important;
  width: 45px !important;
  border-radius: 16px !important;
  /* margin-left: 10px; */
  /* z-index: 99; */
  cursor: pointer;

  ${({ right }) => (right ? "left: unset; right: 20px; position: absolute" : "")};
`;
export const Header = styled.div`
  height: 5% !important;
  display: ${({ theme }) =>
    !["xm"].includes(theme.windowWidth) ? "none" : "flex"};
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #fff !important;
  margin-bottom: 10px !important;
`;
export const HeaderText = styled.div`
  font-size: 24px;
  font-weight: bold;
`;
